<template functional>
  <v-list-tile ripple v-on="listeners" :key="props.id || props.text" class="list-item">
    <v-list-tile-avatar v-if="props.icon">
      <v-icon>{{ props.icon }}</v-icon>
    </v-list-tile-avatar>

    <v-list-tile-title class="list-item__title">{{props.text | capitalize }}</v-list-tile-title>

    <v-list-tile-action>
      <v-icon>chevron_right</v-icon>
    </v-list-tile-action>

  </v-list-tile>
</template>

<script>
export default {
  props: {
    id: [String, Number],
    text: String,
    icon: String,
  },
};
</script>

<style lang="stylus" scoped>
@import "../../../../assets/stylus/variables.styl";

.list-item {
  &__title {
    color: $nx-primary--lighten-5
    font-size: 17px;
    font-weight: 500;
    font-stretch: normal;
    font-style: normal;
    letter-spacing: normal;
  }
}
</style>
